import Portlet from '../../../app/components/portlet/Portlet';
import PortletBody from '../../../app/components/portlet/PortletBody';
import DynamicFormSection from '../components/DynamicFormSection';
import { StyledLabel } from '../../../assets/styledComponents/Global';
import theme from '../../../utils/themes';
import ConnectedJobBoards from '../components/ConnectedJobBoards';
import { useGetAllJobboardsAgainstCompanyQuery } from '../../Products/productApiSlice';
import { useParams } from 'react-router-dom';

const JobBoardsListingContainer = () => {
  const { compId } = useParams();
  const { data: companyJobboards,isFetching:loading ,refetch} = useGetAllJobboardsAgainstCompanyQuery(
    {
      compId: compId
    },
    {
      refetchOnMountOrArgChange: true,
    },
  );
  return (
    <div>
      <Portlet>
        <div className="portlet__body-bg">
          <PortletBody>
            <>
            <div className='d-flex flex-column pt-3 pb-4'>
            <StyledLabel size={'20px'} weight={600} color={theme.headingColor}>Job Boards</StyledLabel>
                <StyledLabel size={'14px'} weight={400} color={theme.headingColor}>Configure and integrate your various job board accounts here</StyledLabel>
          </div>
                <DynamicFormSection
                refetch={refetch}
                companyJobboards={companyJobboards}
                />
            </>
          </PortletBody>
        </div>
      </Portlet>
      {companyJobboards?.jobBoards?.length > 0 &&
<ConnectedJobBoards data={companyJobboards}  refetch={refetch} jobLoading={loading}/>
}
    </div>
  );
};


export default JobBoardsListingContainer;
